import React from 'react'
import styled, { css } from 'styled-components'
import { Button as MdlButton } from 'react-mdl'
import { PRIMARY, ACCENT, LIGHT_GREY, MEDIUM_GREY, DARK_GREY } from '../colors'

const raised = css`
  background-color: ${props =>
    props['data-primary']
      ? PRIMARY
      : props['data-accent'] ? ACCENT : MEDIUM_GREY};
  color: ${props =>
    props['data-primary'] || props['data-accent'] ? 'white' : 'black'};
  box-shadow: ${`0 2px 2px 0 ${LIGHT_GREY}, 0 3px 1px -2px ${DARK_GREY}, 0 1px 5px 0 ${LIGHT_GREY}`};
  &:hover {
    background-color: ${props =>
      props['data-primary']
        ? PRIMARY
        : props['data-accent'] ? ACCENT : MEDIUM_GREY}
  }
`
const flat = css`
  background-color: transparent;
  color: ${props =>
    props['data-primary'] ? PRIMARY : props['data-accent'] ? ACCENT : 'black'};
  box-shadow: none;
  &:hover {
    background-color: ${MEDIUM_GREY};
  }
`
const disabled = css`
  background-color: ${props =>
    props['data-raised'] ? LIGHT_GREY : 'transparent'};
  color: ${DARK_GREY};
  cursor: default;
  box-shadow: none;
  &:hover {
    background-color: ${props =>
      props['data-raised'] ? LIGHT_GREY : 'transparent'};
  }
`

const StyledButton = styled(MdlButton)`
  ${props =>
    props['data-disabled'] ? disabled : props['data-raised'] ? raised : flat};
`

const Button = ({
  onClick,
  onDisabledClick = () => {},
  raised,
  primary,
  accent,
  disabled,
  children,
  ...restProps
}) =>
  <StyledButton
    onClick={disabled ? onDisabledClick : onClick}
    data-raised={raised}
    data-primary={primary}
    data-accent={accent}
    data-disabled={disabled}
    {...restProps}>
    {children}
  </StyledButton>

export default Button



// WEBPACK FOOTER //
// ./src/components/Button.js